import { observer } from 'mobx-react-lite'
import { type TabController } from '@/infra/TabController'
import { type OpportunitiesTab } from '@/features/opportunities/OpportunitiesRootViewModel'
import { OpportunitiesTabBar } from '@/features/opportunities/components/OpportunitiesTabBar'

export interface OpportunitiesTabBarContainerProps {
  tabsController: TabController<OpportunitiesTab>
}

export const OpportunitiesTabBarContainer = observer(
  function OpportunitiesTabBarContainer({
    tabsController,
  }: OpportunitiesTabBarContainerProps) {
    return (
      <OpportunitiesTabBar
        activeTab={tabsController.current.tab}
        onChange={tabsController.change}
      />
    )
  },
)
